var map = {
	"./Anti-Cheat-Monitor.png": 9564,
	"./Automated-Workflow.png": 77587,
	"./Chart.svg": 86829,
	"./Competencies.png": 51388,
	"./CompleteSetup.png": 76099,
	"./CreateAssessment.png": 77825,
	"./Daniel-Redmen.png": 15354,
	"./Esteban-Salsano.jpg": 6497,
	"./Google.svg": 73942,
	"./Image-1.png": 44682,
	"./Image-2.png": 2113,
	"./Image-3.png": 80984,
	"./Image-4.png": 3127,
	"./InviteCandidates.png": 88302,
	"./Landing_page.png": 20598,
	"./Meriem-Terki.png": 46854,
	"./Mounir-Taibi.png": 29149,
	"./Photo_testimony.jpg": 45396,
	"./ProductHunt.svg": 399,
	"./Qatar_flag.svg": 32115,
	"./ToolsIllustration/App-thumbnail.svg": 8305,
	"./ToolsIllustration/App-thumbnail1.svg": 16994,
	"./ToolsIllustration/App-thumbnail10.svg": 45950,
	"./ToolsIllustration/App-thumbnail11.svg": 8527,
	"./ToolsIllustration/App-thumbnail12.svg": 29500,
	"./ToolsIllustration/App-thumbnail13.svg": 58045,
	"./ToolsIllustration/App-thumbnail15.svg": 57155,
	"./ToolsIllustration/App-thumbnail2.svg": 97393,
	"./ToolsIllustration/App-thumbnail3.svg": 40480,
	"./ToolsIllustration/App-thumbnail4.svg": 69855,
	"./ToolsIllustration/App-thumbnail5.svg": 15566,
	"./ToolsIllustration/App-thumbnail6.svg": 26285,
	"./ToolsIllustration/App-thumbnail7.svg": 90828,
	"./ToolsIllustration/App-thumbnail8.svg": 5803,
	"./ToolsIllustration/App-thumbnail9.svg": 538,
	"./accuracy_candidates.svg": 60977,
	"./akar-icons_twitter-fill.svg": 9479,
	"./algeria_svg.svg": 36475,
	"./analyse_step1.png": 76034,
	"./analyse_step1.svg": 11836,
	"./analyse_step3.svg": 28286,
	"./arrow_to_right.svg": 94849,
	"./arrow_to_right_white.svg": 11483,
	"./assessments_setup.png": 26264,
	"./bg_cost.png": 49928,
	"./bg_lines.svg": 24142,
	"./brandico_facebook.svg": 86656,
	"./bx_bxl-linkedin.svg": 49369,
	"./candidate-image.png": 61428,
	"./candidate_evaluation.png": 62047,
	"./close-nav.svg": 55261,
	"./cost_bg2.png": 27768,
	"./cost_chart.svg": 13997,
	"./cost_widget.svg": 37467,
	"./create_step2.svg": 40066,
	"./credit-card.jpg": 47361,
	"./custom_questions_setup.png": 31358,
	"./emptyActivity.svg": 85357,
	"./facebook_setting.svg": 93622,
	"./footer_logo.svg": 88804,
	"./france_flag.svg": 74623,
	"./go_logo-copy.svg": 86657,
	"./go_logo.svg": 94661,
	"./go_logo_blog.svg": 73636,
	"./go_logo_white.svg": 33583,
	"./hamburger-icon.svg": 33862,
	"./icon_copy.svg": 44872,
	"./icon_security_lock.svg": 30341,
	"./icons/AllBoardsIcon.svg": 55883,
	"./icons/Archeive.svg": 9983,
	"./icons/AssignedTasksIcon.svg": 1619,
	"./icons/Avatar.svg": 24813,
	"./icons/Calendar.svg": 99888,
	"./icons/Chart_100.svg": 71950,
	"./icons/Check_icon.svg": 10190,
	"./icons/CompletedTasksIcon.svg": 78814,
	"./icons/Filter.svg": 50760,
	"./icons/Graph.svg": 10994,
	"./icons/Norton_Icon.svg": 16710,
	"./icons/Payment_Apple.svg": 57161,
	"./icons/Payment_mastercard.svg": 643,
	"./icons/Payment_paypal.svg": 46478,
	"./icons/Payment_stripe.svg": 40160,
	"./icons/Payment_visa.svg": 58164,
	"./icons/ScheduledTasksIcon.svg": 60320,
	"./icons/Secure_icon.svg": 30207,
	"./icons/Vector.svg": 68543,
	"./icons/account.svg": 87819,
	"./icons/activity-up.svg": 7045,
	"./icons/adobe-premiere.svg": 90513,
	"./icons/applicant.png": 20882,
	"./icons/assess.png": 32888,
	"./icons/bar-chart-icon.svg": 83512,
	"./icons/bar-chart.svg": 68126,
	"./icons/bar-graph.svg": 68946,
	"./icons/boards.svg": 48701,
	"./icons/build.svg": 97458,
	"./icons/button-dots.svg": 21679,
	"./icons/button-profile.svg": 68454,
	"./icons/chart.svg": 33694,
	"./icons/check-circle.svg": 68103,
	"./icons/check-green.svg": 89096,
	"./icons/chrome_reader_mode.svg": 77648,
	"./icons/close-icon.svg": 52160,
	"./icons/compensation.svg": 35592,
	"./icons/completion.png": 56668,
	"./icons/copy-icon.svg": 99733,
	"./icons/delete.svg": 4179,
	"./icons/department_icon.svg": 94500,
	"./icons/description_icon.svg": 14488,
	"./icons/dots-2.svg": 85671,
	"./icons/edit.svg": 81230,
	"./icons/email.svg": 44886,
	"./icons/fingerprint.svg": 16826,
	"./icons/gantt.svg": 14440,
	"./icons/google-cloud.svg": 39027,
	"./icons/green-circle.svg": 65136,
	"./icons/group.svg": 42715,
	"./icons/ic_telegram.svg": 35352,
	"./icons/ic_whatsapp.svg": 57587,
	"./icons/icon_Phone.svg": 93464,
	"./icons/icon_bag.svg": 83982,
	"./icons/icon_cam.svg": 42249,
	"./icons/icon_category.svg": 18676,
	"./icons/icon_clothes.svg": 84380,
	"./icons/icon_conflict.svg": 93026,
	"./icons/icon_dots.svg": 67184,
	"./icons/icon_down_arrow.svg": 37330,
	"./icons/icon_edit.svg": 55112,
	"./icons/icon_eye.svg": 43923,
	"./icons/icon_eye_closed.svg": 27738,
	"./icons/icon_facebook.svg": 27984,
	"./icons/icon_file.svg": 65126,
	"./icons/icon_github.svg": 80369,
	"./icons/icon_globe.svg": 61691,
	"./icons/icon_hamburger.svg": 25929,
	"./icons/icon_hospital_insurance.svg": 45171,
	"./icons/icon_idea.svg": 31157,
	"./icons/icon_linkedIn.svg": 69746,
	"./icons/icon_location.svg": 1177,
	"./icons/icon_lunch.svg": 54392,
	"./icons/icon_moneybag.svg": 90170,
	"./icons/icon_more.svg": 56927,
	"./icons/icon_people.svg": 23597,
	"./icons/icon_plus.svg": 95116,
	"./icons/icon_share.svg": 5509,
	"./icons/icon_trust.svg": 23858,
	"./icons/icon_type.svg": 80116,
	"./icons/icon_website.svg": 14979,
	"./icons/imagedecor.svg": 39312,
	"./icons/industry_icon.svg": 79136,
	"./icons/invoice.svg": 97823,
	"./icons/job_icon.svg": 31941,
	"./icons/lion.svg": 22568,
	"./icons/list-tasks.svg": 81911,
	"./icons/local_phone.svg": 6858,
	"./icons/lock-icon.svg": 37175,
	"./icons/lock.svg": 77731,
	"./icons/lock_icon.svg": 9565,
	"./icons/mail.svg": 27367,
	"./icons/minus.svg": 61446,
	"./icons/name_icon.svg": 37537,
	"./icons/notes.svg": 38873,
	"./icons/plus.svg": 92846,
	"./icons/profile_image.svg": 78475,
	"./icons/profilepic.png": 53447,
	"./icons/red-half-circle.svg": 74616,
	"./icons/referral.svg": 23117,
	"./icons/search-icon.svg": 30980,
	"./icons/seniority_icon.svg": 33298,
	"./icons/skills_icon.svg": 99940,
	"./icons/slack.svg": 61666,
	"./icons/successRate.png": 88239,
	"./icons/user_icon.svg": 8997,
	"./icons/web_icon.svg": 9536,
	"./icons/white_fb_icon.svg": 96540,
	"./icons/white_instagram_icon.svg": 99216,
	"./icons/white_ln_icon.svg": 10298,
	"./icons/widget-chart.svg": 50769,
	"./instagram.svg": 55909,
	"./instagram_setting.svg": 59924,
	"./invite_screen.png": 84233,
	"./letter1.svg": 30552,
	"./letter2.svg": 85739,
	"./letter3.svg": 66682,
	"./letter4.svg": 78309,
	"./letter5.svg": 23588,
	"./letter6.svg": 50359,
	"./man-cost.svg": 70529,
	"./man_happy.jpg": 25048,
	"./palt.svg": 95730,
	"./percentail_bell_curve.png": 1086,
	"./phone_setting.svg": 19312,
	"./profile.png": 24356,
	"./profileCandidate.svg": 27097,
	"./project_setup.png": 71098,
	"./review_setup.png": 56098,
	"./right_arrow.svg": 32069,
	"./search_icon.svg": 57305,
	"./send_icon.svg": 80263,
	"./shapes.jpg": 13389,
	"./share.svg": 95724,
	"./skills.png": 2749,
	"./talent-map.png": 31324,
	"./talent_mapping.png": 93830,
	"./task_notes.jpg": 71198,
	"./telegram_setting.svg": 58799,
	"./time_chart.svg": 82801,
	"./time_chart2.svg": 61809,
	"./try-image.jpg": 5300,
	"./united-kingdom_flag.svg": 87067,
	"./user.png": 71234,
	"./valueImg1.svg": 57628,
	"./valueImg2.svg": 43599,
	"./valueImg3.svg": 23550,
	"./valueImg4.svg": 40929,
	"./valueImg5.svg": 49808,
	"./valueImg6.svg": 39203,
	"./webchart.svg": 8289,
	"./widget.svg": 71483,
	"./widget2.svg": 93443,
	"./woman_cost.svg": 64537,
	"./woman_productTour.svg": 87757,
	"./woman_productTour2.svg": 16037,
	"./world_map2.svg": 79100
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 80819;